const han = `0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!"#$%&'()0=~|-^@[{;:]+*},./_<>?_`

const zen = `０１２３４５６７８９ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ！＂＃＄％＆＇（）０＝～｜－＾＠［｛；：］＋＊｝，．／＿＜＞？＿`

const map = {
  han: Array.from(han),
  zen: Array.from(zen)
}

export default {
  zenhan (str) {
    const r = Array.from(str).map((s) => {
      const i = map.zen.indexOf(s)
      return i >= 0 ? map.han[i] : s
    })
    return r.join('')
  },

  trim (str) {
    return str.replace(/(^\s+|\s+$)/g, '')
  }
}



// WEBPACK FOOTER //
// ./src/lib/filters.js